/**
Results from GF mbox files on 3/25/2026:
             GoogleVault: 79,566
    GenericAddressAtTime: 19,943
           GoogleTakeout: 1,424
GoogleWorkspaceMigration: 953
         SendmailPostfix: 28
       GoogleTakeoutChat: 8
      MozillaThunderbird: 5
                  Eudora: 3
     LegacyOutlookToMbox: 2
           NobodyAndTime: 2
 ExchangeManagementShell: 1
 */
// Most common, standard
const rx1 =
	/^(\S+) +[A-Z][a-z]{2} +[A-Z][a-z]{2} +\d{1,2} +\d{2}:\d{2}:\d{2} +(?:(\+0{4}) +|([A-Z]{2,4}) +)?\d{4}$/;

// From <Joan.Hollick@metrotransit.org> Mon, 11 Jan 2021 14:38:08 -0000
const rx2 = /^(\S+) +[A-Z][a-z]{2}, +\d{1,2} +[A-Z][a-z]{2} +\d{4} +\d{2}:\d{2}:\d{2} +-0000$/;

// From calise@peopleschoicehospital.com 02/03/2016 05:55:57 PM
const rx3 = /^(\S+) +\d{1,2}\/\d{1,2}\/\d{4} +\d{2}:\d{2}:\d{2} +(?:AM|PM)$/;

export const enum EMboxFromSig {
	UNKNOWN = 'UNKNOWN',
	MozillaThunderbird = 'MozillaThunderbird',
	GoogleTakeout = 'GoogleTakeout',
	GoogleTakeoutChat = 'GoogleTakeoutChat',
	GoogleVault = 'GoogleVault',
	GoogleWorkspaceMigration = 'GoogleWorkspaceMigration',
	Eudora = 'Eudora',
	GenericAddressAndTime = 'GenericAddressAndTime',
	GenericNameAndTime = 'GenericNameAndTime',

	// Gemini / AI guessed
	LegacyOutlookToMbox = 'LegacyOutlookToMbox',
	SendmailPostfix = 'SendmailPostfix',
	ExchangeManagementShell = 'ExchangeManagementShell',
	Metamail = 'Metamail',
}

export function identifyFromLine(str: string): EMboxFromSig {
	if (str.startsWith('From ')) {
		str = str.slice(5);
	}

	const match1 = rx1.exec(str);
	if (match1) {
		const [, name, tz1, tz2] = match1;

		// console.dir({ name, tz1, tz2 });
		if (tz2 && /^[^@]+@[^@]+$/.test(name)) {
			return EMboxFromSig.Metamail;
		}

		// Allow optional tz1
		if (/^\d{19}@xxx$/.test(name)) {
			return EMboxFromSig.GoogleTakeout;
		}

		if (!tz1 && !tz2) {
			if (name === '-') {
				return EMboxFromSig.MozillaThunderbird;
			} else if (name === '???@???') {
				return EMboxFromSig.Eudora;
			} else if (name === 'MAILER-DAEMON') {
				return EMboxFromSig.SendmailPostfix;
			} else if (/<[a-z0-9]+_[a-z0-9]+_chat@gmail.com>/.test(name)) {
				return EMboxFromSig.GoogleTakeoutChat;
			} else if (
				/^\d{19}-[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\.mbox@xxx$/.test(
					name
				)
			) {
				return EMboxFromSig.GoogleWorkspaceMigration;
			} else if (/^\d{19}-\d{13}$/.test(name)) {
				return EMboxFromSig.GoogleVault;
			} else if (/^[^@]+@[^@]+$/.test(name)) {
				return EMboxFromSig.GenericAddressAndTime;
			} else {
				return EMboxFromSig.GenericNameAndTime;
			}
		}
	}

	const match2 = rx2.exec(str);
	if (match2 && /^<[^@]+@[^@]+>$/.test(match2[1])) {
		return EMboxFromSig.LegacyOutlookToMbox;
	}

	const match3 = rx3.exec(str);
	if (match3 && /^[^@]+@[^@]+$/.test(match3[1])) {
		return EMboxFromSig.ExchangeManagementShell;
	}

	return EMboxFromSig.UNKNOWN;
}
